var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHurtsWorstSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_319_1327)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 18,
    stroke: "#EE664E",
    strokeWidth: 3.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 41C34.2843 41 41 34.2843 41 26C41 17.7157 34.2843 11 26 11C17.7157 11 11 17.7157 11 26C11 34.2843 17.7157 41 26 41Z",
    fill: "#EE664E",
    stroke: "#EE664E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8974 27.0004C21.5004 27.0004 22.8 25.661 22.8 24.0088C22.8 22.8892 22.2032 21.9133 21.3196 21.4004L17.2 25.1157C17.6269 26.22 18.6737 27.0004 19.8974 27.0004Z",
    fill: "#731C0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1026 27.0004C30.4996 27.0004 29.2 25.661 29.2 24.0088C29.2 22.8892 29.7968 21.9133 30.6804 21.4004L34.8 25.1157C34.3731 26.22 33.3263 27.0004 32.1026 27.0004Z",
    fill: "#731C0C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33.1C34 33.9837 33.2837 34.7 32.4 34.7C31.5164 34.7 30.8 33.9837 30.8 33.1C30.8 32.2163 31.5164 28.5 32.4 28.5C33.2837 28.5 34 32.2163 34 33.1Z",
    fill: "#731C0C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3721 30.5522C28.3287 29.9261 27.1728 29.5996 26 29.5996C24.8272 29.5996 23.6713 29.9261 22.6279 30.5522C21.5845 31.1782 20.6837 32.0857 20 33.1996",
    stroke: "#731C0C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3767 19.7838C32.7344 21.3374 33.6825 21.8848 35.7068 22.2838",
    stroke: "#731C0C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6201 19.7838C19.2624 21.3374 18.3143 21.8848 16.29 22.2838",
    stroke: "#731C0C",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_319_1327",
    x: 0.0000243187,
    y: 0.00039053,
    width: 52,
    height: 51.9992,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.2,
    result: "effect1_foregroundBlur_319_1327"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHurtsWorstSelected);
export default __webpack_public_path__ + "static/media/hurts-worst-selected.58dbc7134d6b1949c6cfb0af4ae72022.svg";
export { ForwardRef as ReactComponent };